module.exports = __webpack_public_path__ + "static/media/icono_salvado.e450c11b.png";